const europeanCharMap: { [key: string]: string } = {
    İ: 'I',
    à: 'a',
    À: 'A',
    á: 'a',
    Á: 'A',
    â: 'a',
    Â: 'A',
    ã: 'a',
    Ã: 'A',
    å: 'a',

    Å: 'A',
    æ: 'ae',
    Æ: 'AE',
    ç: 'c',
    Ç: 'C',
    è: 'e',
    È: 'E',
    é: 'e',

    É: 'E',
    ê: 'e',
    Ê: 'E',
    ë: 'e',

    Ë: 'E',
    ì: 'i',
    Ì: 'I',
    í: 'i',
    Í: 'I',
    î: 'i',
    Î: 'I',
    ï: 'i',
    Ï: 'I',
    ð: 'd',

    Ð: 'D',
    ñ: 'n',

    Ñ: 'N',
    ò: 'o',
    Ò: 'O',
    ó: 'o',
    Ó: 'O',
    ô: 'o',

    Ô: 'O',
    õ: 'o',
    Õ: 'O',
    ø: 'o',
    Ø: 'O',
    ù: 'u',

    Ù: 'U',
    ú: 'u',
    Ú: 'U',
    û: 'u',
    Û: 'U',
    ý: 'y',

    Ý: 'Y',
    þ: 'th',
    Þ: 'Th',
    ă: 'a',
    Ă: 'A',
    ć: 'c',
    Ć: 'C',
    č: 'c',
    Č: 'C',
    ď: 'd',
    Ď: 'D',
    đ: 'd',
    Đ: 'D',
    ē: 'e',
    Ē: 'E',
    ė: 'e',
    Ė: 'E',
    ě: 'e',
    Ě: 'E',
    ğ: 'g',
    Ğ: 'G',
    ı: 'i',

    ĺ: 'l',
    Ĺ: 'L',
    ľ: 'l',
    Ľ: 'L',

    ł: 'l',
    Ł: 'L',
    ń: 'n',
    Ń: 'N',
    ň: 'n',
    Ň: 'N',

    ő: 'o',
    Ő: 'O',
    ř: 'r',
    Ř: 'R',
    Ś: 'S',
    ś: 's',
    ş: 's',
    Ş: 'S',

    š: 's',
    Š: 'S',
    ť: 't',
    Ť: 'T',

    ū: 'u',
    Ū: 'U',

    ů: 'u',
    Ů: 'U',

    ű: 'u',
    Ű: 'U',
    ų: 'u',
    Ų: 'U',

    Ż: 'Z',
    ż: 'z',
    ž: 'z',
    Ž: 'Z',

    ș: 's',
    Ș: 'S',
    ț: 't',
    Ț: 'T',

    Ẅ: 'W',
    ẅ: 'w',
};

const allowedGermanChars = new Set(['Ü', 'Ö', 'Ä', 'ü', 'ö', 'ä', 'ß']);
const allowedLatinLetters = /^[a-zA-Z]$/;

export function replaceSpecialChars(input: string): string {
    return [...input]
        .map((char) => {
            if (allowedGermanChars.has(char) || allowedLatinLetters.test(char)) {
                return char; // Allow German Umlauts, ß, and regular Latin letters
            }
            if (europeanCharMap[char]) {
                return europeanCharMap[char];
            }
            // NFD fallback for any diacritic not in the explicit map (e.g. Polish ź/ą/ę, combining marks)
            return char.normalize('NFD').replace(/\p{M}/gu, '');
        })
        .join('')
        .replace(/['´`",.;:]/g, '');
}
